<div
  class="mib-dialog flex flex-col gap-8"
  role="dialog"
  aria-labelledby="resume-session-title"
>
  <header class="shrink-0">
    <mai-mib-logo></mai-mib-logo>
  </header>

  <h2
    id="resume-session-title"
    class="text-2xl max-lg:landscape:text-xl text-branding-primary text-center"
  >
    Would you like to resume the previous session?
  </h2>

  <footer class="flex w-full flex-col gap-4 sm:flex-row">
    <!-- Keep the previous live's context -->
    <mib-button class="w-full" theme="secondary" (click)="dialogRef.close('resume')">
      Continue session
    </mib-button>
    <!-- Start over with a fresh context -->
    <mib-button class="w-full" theme="danger" (click)="dialogRef.close('new')">
      Start a new session
    </mib-button>
  </footer>
</div>
